<template>
  <div class="top_navBox">
    <router-link
      class="top_a"
      id="navIn"
      v-for="(item, index) in list"
      :key="index"
      :to="item.path"
    >
      <div class="top_a_center">
        <span :class="url == item.path ? 'addColor' : ''">{{
          lange == "ch" ? item.title : item.name
        }}</span>
        <i v-if="url == item.path"></i>
      </div>
    </router-link>
    <div id="chen" class="languagebox" @click="langeFuc">
      <span :style="lange == 'en' ? 'color:#c0913e;' : ''">EN</span>/<span
        :style="lange == 'ch' ? 'color:#c0913e;' : ''"
        >中文</span
      >
    </div>

    <i class="el-icon-menu webNav" @click="isShowShuoji" style="font-size: 25px;"></i>

    <!-- 手机端导航 start -->
    <div class="NavYdong" v-if="nwebshow" @click="clickwebHide">
      <div
        class="nav_c"
        :style="nwebshow == false ? 'right: -220px;' : 'right:0;'"
        @click.stop=""
      >
        <div class="nav_cener" style="margin-top: 60px;">
          <router-link
            class="top_a"
            v-for="(item, index) in list"
            :key="index"
            :to="item.path"
          >
            <div class="top_a_center">
              <span :class="url == item.path ? 'addColor' : ''">{{
                lange == "ch" ? item.title : item.name
              }}</span>
              <i v-if="url == item.path"></i>
            </div>
          </router-link>
          <div class="languagebox2" @click="langeFuc">
            <span :style="lange == 'en' ? 'color:#c0913e;' : ''">EN</span>/<span
              :style="lange == 'ch' ? 'color:#c0913e;' : ''"
              >中文</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 手机端导航 end -->
  </div>
</template>

<script>
export default {
  inject: ["reload"], // 注入重载的功能（注入依赖）
  name: "NavBox",
  //监视
  watch: {
    //检测路由参数发生改变时，刷新当前页面 调用
    $route: function () {
      // this.reload();
    },
  },
  data() {
    return {
      list: [],
      url: "",
      lange: null,
      nwebshow: false,
    };
  },
  computed: {
    handleselect: function (a, b) {
      this.reload(); // 点击侧边栏重新载入页面
    },
    routerNav() {
      var arr = [];
      for (var i = 0; i < this.$router.options.routes.length; i++) {
        if (this.$router.options.routes[i].show == true) {
          arr.push(this.$router.options.routes[i]);
        }
      }
      return arr;
    },
    pathUrl() {
      return this.$router.history.current.path;
    },
    langeComp() {
      return this.$cookies.getCookie("language");
    },
  },
  created() {
    this.$nextTick(() => {
      this.list = this.routerNav;
      this.url = this.pathUrl;
      this.lange = this.langeComp;
    });
  },
  methods: {
    langeFuc() {
      if (this.langeComp == "ch") {
        this.lange = "en";
        this.$cookies.setCookie("language", "en");
        this.reload();
      } else {
        this.lange = "ch";
        this.$cookies.setCookie("language", "ch");
        this.reload();
      }
    },
    isShowShuoji() {
      if (this.nwebshow) {
        this.nwebshow = false;
      } else {
        this.nwebshow = true;
      }
    },
    clickwebHide() {
      this.nwebshow = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top_navBox {
  display: flex;
  justify-content: space-between;
  height: 80px;
  position: absolute;
  top: 0;
  right: 0;
}
.top_a {
  padding: 0 23px;
  display: block;
}
.top_a_center {
  width: 100%;
  display: block;
  margin: 28px 0 0 0;
}
.top_a_center > span {
  width: 100%;
  display: block;
  font-size: 12px;
  color: #b5b5b5;
  text-align: center;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.addColor {
  color: #bda67d !important;
}
.top_a_center > i {
  width: 120%;
  height: 2px;
  display: block;
  background-color: #bda67d;
  margin-left: -10%;
  margin-top: 7px;
}

.languagebox {
  display: block;
  position: absolute;
  right: -50px;
  top: 28px;
  font-size: 12px;
  color: #b5b5b5;
  letter-spacing: 1px;
  cursor: pointer;
}
.languagebox2 {
  width: 100%;
  display: block;
  font-size: 12px;
  color: #b5b5b5;
  letter-spacing: 1px;
  cursor: pointer;
  text-align: center;
  margin-top: 20px;
}

/* 手机端 */
.webNav {
  width: 40px;
  height: 40px;
  display: none;
  position: absolute;
  top: 47%;
  right: 0;
  margin-top: -20px;
  font-size: 40px;
  color: #ccc;
}
.NavYdong {
  width: 100%;
  height: 100%;
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 100;
  transition: 0.3s;
}
.nav_c {
  width: 120px;
  height: 100%;
  display: block;
  position: absolute;
  background-color: #fff;
  top: 0;
  transition: 0.3s;
  opacity: 0.9;
}

@media only screen and (max-width: 1024px) {
  #navIn {
    display: none;
  }
  #chen {
    display: none;
  }
  .webNav {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar/component/NavBox.vue